import { vestResolver } from "@hookform/resolvers/vest";
import { FC, useEffect, useRef, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { UseSalarySimContext } from "../Context/SalarySimContext";
import { FormSuite } from "../FormModel/FormValidator_Step2_Advanced";
import InputData from "../Model/InputData";
import { SalSimFormProps } from "../FormModel/FormStepProps";
import { UseCodeListContext } from "../Context/CodeListContext";
import { UseTranslationContext } from "../Context/TranslationContext";
import { UseToastContext, toastType } from "../Context/ToastContext";
import FormToggleElementDualChoice from "./FormToggleElementDualChoice";
import { ConstructionOutlined } from "@mui/icons-material";
import { convertToHoursAndMinutesString } from "./PrestaProcessHelper";
import { withHookFormMask } from 'use-mask-input';
import { useMediaQuery } from "@mui/material";

const Step2Advanced:FC<SalSimFormProps> = (props) => {

    //INIT Var
    const {forceJointComiteeUpdate, setCurrentSelectedContract, codeListForm, getCodeListKey, codeListJointCommittee, refreshCodeListNSSOPrefix, codeListNSSOPrefix, getJointComiteeKey, prestaUpdateInProgress, setPrestaUpdateInProgress} = UseCodeListContext();
    const{salarySimAdvancedFormData, updateSalarySimData } = UseSalarySimContext();
    const{getKeyFromKeyId} = UseTranslationContext();
    const { popToast } = UseToastContext();

    const isAtBreakpoint = useMediaQuery('screen and (max-width: 479px)');

    // Startup first init
    // We load the validated existing data from the context
      useEffect(() => {

        //init
        if(salarySimAdvancedFormData != null)
        {
            setValue('NetToBrutCheck', salarySimAdvancedFormData.NetToBrut);
            setValue('MonthlyMoneyAmount', salarySimAdvancedFormData.MonthlyAmount);
            setValue('GroupInsurance', salarySimAdvancedFormData.CollectiveInsuranceAmount);
  
            setValue('SelectedContract', salarySimAdvancedFormData.ContractType);
            setValue("selectedComParitaire", salarySimAdvancedFormData.JointCommittee);
            setValue("selectedPrefixeOnss", salarySimAdvancedFormData.OnssPrefix);
        }
  
        setValue('MondaySchedule','07:36');
        setValue('TuesdaySchedule','07:36');
        setValue('WednesdaySchedule','07:36');
        setValue('ThursdaySchedule','07:36');
        setValue('FridaySchedule','07:36');
        setValue('SaturdaySchedule','00:00');
        setValue('SundaySchedule','00:00');
        
        setValue('MondayScheduleRef','07:36');
        setValue('TuesdayScheduleRef','07:36');
        setValue('WednesdayScheduleRef','07:36');
        setValue('ThursdayScheduleRef','07:36');
        setValue('FridayScheduleRef','07:36');
        setValue('SaturdayScheduleRef','00:00');
        setValue('SundayScheduleRef','00:00');
  
      }, []);
 
      // LOADING PRESTA
      useEffect(() => {
        if(salarySimAdvancedFormData != null)
        {
          if(salarySimAdvancedFormData.loadFromPresta == true)
          {
            setValue("onssCheckbox", salarySimAdvancedFormData.OnssSubmitted);
            setValue("partTimeValue", salarySimAdvancedFormData.PartTime);
            setValue("SecondaryActivity", salarySimAdvancedFormData.SecondaryActivity);
            
            setValue("selectedTypeContrat", salarySimAdvancedFormData.ContractType);

            // if the imported data has the same contract type, we have to force another value to trigger a refresh because setting selectedTypeContrat dirty doesn't trigger the hook.
            var currentContractNum = parseInt(formContractType);
            if(isNaN(currentContractNum) == false && currentContractNum != undefined)
            {
              if(salarySimAdvancedFormData.ContractType == currentContractNum)
              {
                forceJointComiteeUpdate();
              }
            }

            if (salarySimAdvancedFormData.OnssSubmitted == false){
              setValue("selectedComParitaire", null);
              setValue("selectedPrefixeOnss", null);
            }

            setPrestaUpdateInProgress(true);

            setValue("selectedEffectifEmployeur", salarySimAdvancedFormData.NumberEmployees);
            setValue("selectedSoumisPrecompte", salarySimAdvancedFormData.ProfDeductionSubmitted);

            if(salarySimAdvancedFormData.PartTime)
            {
              setValue('MondaySchedule',convertToHoursAndMinutesString(salarySimAdvancedFormData.MondaySchedule));
              setValue('TuesdaySchedule',convertToHoursAndMinutesString(salarySimAdvancedFormData.TuesdaySchedule));
              setValue('WednesdaySchedule',convertToHoursAndMinutesString(salarySimAdvancedFormData.WednesdaySchedule));
              setValue('ThursdaySchedule',convertToHoursAndMinutesString(salarySimAdvancedFormData.ThursdaySchedule));
              setValue('FridaySchedule',convertToHoursAndMinutesString(salarySimAdvancedFormData.FridaySchedule));
              setValue('SaturdaySchedule',convertToHoursAndMinutesString(salarySimAdvancedFormData.SaturdaySchedule));
              setValue('SundaySchedule',convertToHoursAndMinutesString(salarySimAdvancedFormData.SundaySchedule));
              
              setValue('MondayScheduleRef',convertToHoursAndMinutesString(salarySimAdvancedFormData.MondayScheduleRef));
              setValue('TuesdayScheduleRef',convertToHoursAndMinutesString(salarySimAdvancedFormData.TuesdayScheduleRef));
              setValue('WednesdayScheduleRef',convertToHoursAndMinutesString(salarySimAdvancedFormData.WednesdayScheduleRef));
              setValue('ThursdayScheduleRef',convertToHoursAndMinutesString(salarySimAdvancedFormData.ThursdayScheduleRef));
              setValue('FridayScheduleRef',convertToHoursAndMinutesString(salarySimAdvancedFormData.FridayScheduleRef));
              setValue('SaturdayScheduleRef',convertToHoursAndMinutesString(salarySimAdvancedFormData.SaturdayScheduleRef));
              setValue('SundayScheduleRef',convertToHoursAndMinutesString(salarySimAdvancedFormData.SundayScheduleRef));
            }

            props.formPrestaLoaded(2);
          }
        }

      }, [salarySimAdvancedFormData]);

        // Form init
    const {register, handleSubmit, getValues, setValue, formState: {errors}, control} = useForm({
          resolver:vestResolver(FormSuite),
          mode:'onChange',
          reValidateMode: 'onChange',
          context: undefined,
          criteriaMode: "firstError",
          shouldFocusError: false,
          shouldUnregister: false,
          delayError: undefined,
      });

    const formRefStep2A = useRef<HTMLFormElement>(null);

    const formOnssCheck = useWatch({ control, name: "onssCheckbox", defaultValue: (salarySimAdvancedFormData.OnssSubmitted != undefined)?salarySimAdvancedFormData.OnssSubmitted:false});
    const formPartTimeValue = useWatch({ control, name: "partTimeValue", defaultValue: (salarySimAdvancedFormData.PartTime != undefined)?salarySimAdvancedFormData.PartTime:false});
    const formNSSOPrefix = useWatch({ control, name: "selectedPrefixeOnss", defaultValue: (salarySimAdvancedFormData.OnssPrefix != undefined)?salarySimAdvancedFormData.OnssPrefix:"0"});
    const formContractType = useWatch({ control, name: "selectedTypeContrat",defaultValue: 1});
    const formJc = useWatch({ control, name: "selectedComParitaire" });
    const formSecondaryActivityCheck = useWatch({ control, name: "SecondaryActivity",defaultValue:false});
    const [isNssoAccessible, setIsNssoAccessible] = useState(true);
    const [displaySecondaryActivity, setDisplaySecondaryActivity] = useState(false);

    const [formScheduleTotalEmployee, setFormScheduleTotalEmployee] = useState("00:00");
    const [formScheduleTotalEmployer, setFormScheduleTotalEmployer] = useState("00:00");

    const TogglePartialTimeState = (onState : boolean) => {
      onState?setValue("partTimeValue", false): setValue("partTimeValue", true);
    };

    const UpdateNSSO = () => {
      if(isNssoAccessible)
      {
        setValue("SecondaryActivity", !formSecondaryActivityCheck );
      }
    }
  
    const NSSOToggleClick = () => {
      if(isNssoAccessible)
      {
        setValue("onssCheckbox", !formOnssCheck );
      }
    };

    // CONTRACT TYPE TRIGGER
    useEffect(() => {
      let currentContractType = parseInt(formContractType);
      if (isNaN(currentContractType)) return;

      setCurrentSelectedContract(formContractType);

      // setting default "non submitted" in dropdown for students 840 ( 6 ) and 841 ( 7 )
      let defaultDeductionValue = ["6", "7"].includes(formContractType) ? "0" : "1";
      setValue("selectedSoumisPrecompte", defaultDeductionValue);

      let nssoAccess = ![5, 8].includes(currentContractType);
      setIsNssoAccessible(nssoAccess);
      if (!nssoAccess){
        setValue("onssCheckbox", false);
        setValue("selectedComParitaire", null);
        setValue("selectedPrefixeOnss", null);
      }
      else
      {
        setValue("onssCheckbox", true);
      }

      setDisplaySecondaryActivity((currentContractType==48) || (currentContractType==454));
    }, [formContractType]);

    // JOIT COMMITTEE LIST TRIGGER
    useEffect(() => {
      if (codeListJointCommittee == undefined || codeListJointCommittee.length == 0) {
        return;
      }

      if(prestaUpdateInProgress == false) // normal method
      {
        setValue("selectedComParitaire", codeListJointCommittee[0].keyValNum);
      }
      else // presta or history import
      {
        if(salarySimAdvancedFormData.OnssSubmitted == false)
        {
          setValue("selectedComParitaire", null);
        }
        else
        {    
          var jcNum = parseInt(salarySimAdvancedFormData.JointCommittee);
          var cljcfiltered = codeListJointCommittee.filter(element => element.keyValNum == jcNum);
          if(cljcfiltered.length > 0)
          {
            setValue("selectedComParitaire", jcNum);
            if(formJc == jcNum) // forcing a refresh because the trigger in the form doesn't work if it is the same value
            {
              refreshCodeListNSSOPrefix(jcNum, parseInt(formContractType));
            }
          }
          else
          {
            let key = "ERROR_CP_NOT_FOUND";
            popToast(toastType.Warning, getKeyFromKeyId(key), key);
            setValue("selectedComParitaire", codeListJointCommittee[0].keyValNum);
          }
        }
      }
    }, [codeListJointCommittee]);

    // JOINT COMMITTEE FORM TRIGGER
    useEffect(() => {

      let currentContractType = parseInt(formContractType);
      let currentJcNum = parseInt(formJc);

      if (isNaN(currentJcNum) || isNaN(currentContractType))
      {
        return;
      }

      if(prestaUpdateInProgress == false) // normal method
      {
        var cljcfiltered = codeListJointCommittee.filter(element => element.keyValNum == currentJcNum);
        if(cljcfiltered.length > 0)
        {
          let currentJcNumber = codeListJointCommittee.filter(element => element.keyValNum == currentJcNum)[0].keyValNum;
          if (currentJcNumber != null && currentJcNumber != undefined && isNaN(currentJcNumber) == false)
          {
            refreshCodeListNSSOPrefix(currentJcNumber, currentContractType);
          }
        }
      }
      else
      {
        refreshCodeListNSSOPrefix(currentJcNum, currentContractType);
      }
    }, [formJc]);

    // NSSO LIST TRIGGER
    useEffect(() => {
      if(codeListNSSOPrefix == undefined || codeListNSSOPrefix.length == 0)
      {
        return;
      }

      if(prestaUpdateInProgress == false) // normal method
      {
        setValue("selectedPrefixeOnss", codeListNSSOPrefix[0].keyValNum.toString());
      }
      else // presta or history import
      {
        if(salarySimAdvancedFormData.OnssSubmitted == false)
        {
          setValue("selectedPrefixeOnss", null);
        }
        else
        {
          var nssoNum = parseInt(salarySimAdvancedFormData.OnssPrefix);
          var nssoFiltered = codeListNSSOPrefix.filter(x => x.keyValNum == nssoNum);
          if(nssoFiltered.length > 0)
          {
            setValue("selectedPrefixeOnss", nssoNum.toString());
          }
          else
          {
            let key = "ERROR_NSSO_NOT_FOUND";
            popToast(toastType.Warning, getKeyFromKeyId(key), key);
            setValue("selectedPrefixeOnss", codeListNSSOPrefix[0].keyValNum.toString());
          }
        }
        setPrestaUpdateInProgress(false); // the nsso update is the last step so we end the import here
      }

    }, [codeListNSSOPrefix]);
    
  // FORM VALIDATION
  useEffect(() => {
      if (props.requestFormValidation != null && props.requestFormValidation.includes(props.formStep) && formRefStep2A.current) {
      formRefStep2A.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  },[props.requestFormValidation])

  // FORM SUBMIT : UPDATE DATA CONTEXT
  const SendSalarySimForm=(data:any, GoToNextForm : boolean = true) => {
      let step2Data : InputData = new InputData();
            
      step2Data.ContractType=(typeof(formContractType) != "number")?parseInt(formContractType):formContractType;

      step2Data.OnssSubmitted=data?.onssCheckbox;
      step2Data.JointCommittee=(data?.selectedComParitaire)?data?.selectedComParitaire.toString():"";
      step2Data.NumberEmployees=data?.selectedEffectifEmployeur;

      step2Data.OnssPrefix=(data?.selectedPrefixeOnss != undefined && data?.selectedPrefixeOnss != null)?data?.selectedPrefixeOnss.toString():"";
      step2Data.ProfDeductionSubmitted=data?.selectedSoumisPrecompte;
      step2Data.SecondaryActivity = data.SecondaryActivity ?? false;
      step2Data.PartTime=false;

      if(formPartTimeValue)
      {
        step2Data.PartTime=true;

        step2Data.MondaySchedule=ConvertToMinutes(data?.MondaySchedule);
        step2Data.TuesdaySchedule=ConvertToMinutes(data?.TuesdaySchedule);
        step2Data.WednesdaySchedule=ConvertToMinutes(data?.WednesdaySchedule);
        step2Data.ThursdaySchedule=ConvertToMinutes(data?.ThursdaySchedule);
        step2Data.FridaySchedule=ConvertToMinutes(data?.FridaySchedule);
        step2Data.SaturdaySchedule=ConvertToMinutes(data?.SaturdaySchedule);
        step2Data.SundaySchedule=ConvertToMinutes(data?.SundaySchedule);

        step2Data.MondayScheduleRef=ConvertToMinutes(data?.MondayScheduleRef);
        step2Data.TuesdayScheduleRef=ConvertToMinutes(data?.TuesdayScheduleRef);
        step2Data.WednesdayScheduleRef=ConvertToMinutes(data?.WednesdayScheduleRef);
        step2Data.ThursdayScheduleRef=ConvertToMinutes(data?.ThursdayScheduleRef);
        step2Data.FridayScheduleRef=ConvertToMinutes(data?.FridayScheduleRef);
        step2Data.SaturdayScheduleRef=ConvertToMinutes(data?.SaturdayScheduleRef);
        step2Data.SundayScheduleRef=ConvertToMinutes(data?.SundayScheduleRef);    
      }

      if(updateSalarySimData != undefined)
      {
          updateSalarySimData(step2Data, 2, false);
      }

      props.formValidationCallback(props.formStep, true);
   }

   // FORM SUBMIT VALIDATION FAIL CALLBACK
   const onFormError = (formErrors : any, e : any) =>{
    props.formValidationCallback(props.formStep, false);
  }

  // HELPERS
  const ConvertToMinutes=(HourMinute:string) =>{

    let [hours, minutes] = HourMinute.split(':');
    let totMinutes=(parseInt(hours) * 60);
    if(parseInt(minutes) > 0)
    {
        totMinutes=totMinutes + parseInt(minutes);
    }
    return totMinutes.toString();
  };

  // Display Total hours / min for part time schedule
  const ToHoursAndMinutes = (totalMinutes : number) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return { hours, minutes };
  }

  const RefreshScheduleDays = (e:any, isemployee: boolean) => {
    if(formPartTimeValue == true)
    {
      var scheduleValues : Array<any>;
      var minutes = 0;

      if(isemployee)
      {
        scheduleValues = getValues(['MondaySchedule','TuesdaySchedule','WednesdaySchedule','ThursdaySchedule','FridaySchedule','SaturdaySchedule','SundaySchedule']);
      }
      else
      {
        scheduleValues = getValues(['MondayScheduleRef','TuesdayScheduleRef','WednesdayScheduleRef','ThursdayScheduleRef','FridayScheduleRef','SaturdayScheduleRef','SundayScheduleRef']);
      }

      minutes += GetDayValue(scheduleValues[0]);
      minutes += GetDayValue(scheduleValues[1]);
      minutes += GetDayValue(scheduleValues[2]);
      minutes += GetDayValue(scheduleValues[3]);
      minutes += GetDayValue(scheduleValues[4]);
      minutes += GetDayValue(scheduleValues[5]);
      minutes += GetDayValue(scheduleValues[6]);

      var toHoursMin = ToHoursAndMinutes(minutes);

      if(isemployee)
      {
        setFormScheduleTotalEmployee(toHoursMin.hours + ":" + toHoursMin.minutes.toString().padStart(2, '0'));
      }
      else
      {
        setFormScheduleTotalEmployer(toHoursMin.hours + ":" + toHoursMin.minutes.toString().padStart(2, '0'));
      }
    }
  };

  const GetDayValue = (formDayValue: any) => {
    var convertedValue = parseInt(ConvertToMinutes(formDayValue));
    return (isNaN(convertedValue)?0:convertedValue);
  }

  useEffect(() => {
    if (formPartTimeValue == true) {
      RefreshScheduleDays(null, true);
      RefreshScheduleDays(null, false);
    }
  }, [formPartTimeValue]);

  // JSX return
    return (
      
    <div style={{display:(props.isCurrentForm?'':'none')}}>

    <form ref={formRefStep2A} id="formStep2Advanced" name="wf-form-Etape2-avanc" onSubmit={handleSubmit((d) => SendSalarySimForm(d), (data, e) => onFormError(data,e))} data-name="Etape2-avancé" method="post" aria-label={getKeyFromKeyId("SECTION_CONTRACT_TYPE")} className="form-step2-avance formIndex">
    
          <div id="group-field-contrat" className="group-field">
            <div className="group-label">
              <label aria-hidden="true" htmlFor="type-de-contrat" className="field-label">{getKeyFromKeyId("TYPE_CONTRAT")}</label></div>
              <select {...register('selectedTypeContrat')} className="select-field w-select inputFixedMaxHeight">
              {codeListForm.clContrPlus.map((item) =>
                        <option key={item.keyId + item.keyValNum} value={item.keyValNum}>{getCodeListKey(item.keyId, item.keyValNum)}</option> 
              )}
            </select>
          </div>

          <div tabIndex={0} role="checkbox" aria-checked={formOnssCheck} id="group-field-onss" className="group-toggle left">
            <p className="label-toggle">{getKeyFromKeyId("SOUMIS_ONSS")}</p>
            <div id="toggle-container" className="toggle-container">
              <div onClick={() => NSSOToggleClick()} className={formOnssCheck?"toggle-appearance":"toggle-appearance off disable grey"}>
                <div className="toggle"></div>
              </div>
              <label className="w-checkbox checkbox-disable" htmlFor="onssCheckbox">
                <input {...register("onssCheckbox")} type="checkbox" id="onssCheckbox" className="w-checkbox-input checkbox-2" disabled={!isNssoAccessible} />
                <span className={formOnssCheck?"text-toggle actif w-form-label":"text-toggle w-form-label"} >{(formOnssCheck ? getKeyFromKeyId("OUI") : getKeyFromKeyId("NON"))}</span>
              </label>
            </div>
          </div>

          {/* Checkbox only shown when type_contrat = sportif, otherwise set to false */}
          { displaySecondaryActivity &&
          <>
          <div tabIndex={0} role="checkbox" aria-checked={formSecondaryActivityCheck} id="w-node-bb0f05d9-8490-1236-d704-2135439a38b2-1b011521" className="group-toggle left">
            <p className="label-toggle">{getKeyFromKeyId("ACTIVITE_SECONDAIRE")}</p>
            <div id="toggle-container" className="toggle-container">
              <div onClick={() => UpdateNSSO()} className={formSecondaryActivityCheck?"toggle-appearance":"toggle-appearance off disable grey"}>
                <div className="toggle"></div>
              </div>
              <label className="w-checkbox checkbox-disable" htmlFor="SecondaryActivity">
                <input {...register("SecondaryActivity")} type="checkbox" id="SecondaryActivity"  className="w-checkbox-input checkbox-2" />
                <span className={formSecondaryActivityCheck?"text-toggle actif w-form-label":"text-toggle w-form-label"} >{(formSecondaryActivityCheck ? getKeyFromKeyId("OUI") : getKeyFromKeyId("NON"))}</span>
              </label>
            </div>
            </div>
            </>
          }

          { formOnssCheck &&
          <>
            <div id="group-field-commission" className="group-field">
            <div className="group-label">
              <label aria-hidden="true" htmlFor="commission" className="field-label">{getKeyFromKeyId("COM_PARITAIRE")}</label></div>
              <select {...register('selectedComParitaire')} className="select-field w-select inputFixedMaxHeight">
                {
                  codeListJointCommittee.map(element => <option value={element.keyValNum} key={element.keyValNum} title={getJointComiteeKey(element.keyValNum, false)}>{element.keyValString + " - " + getJointComiteeKey(element.keyValNum, true)}</option>)
                }
            </select>
          </div>
          <div id="group-field-prefixe" className="group-field">
            <div className="group-label"><label aria-hidden="true" htmlFor="prefixe" className="field-label">{getKeyFromKeyId("PREFIXE_ONSS")}</label></div>
            <select {...register('selectedPrefixeOnss')} className="select-field w-select inputFixedMaxHeight">
                {
                  codeListNSSOPrefix.map(element => <option value={element.keyValNum} key={element.keyValNum + element.keyValString}>{element.keyFr}</option>)
                }
            </select>
          </div>
          </>
          }

          <div id="group-field-employeur" className="group-field">
            <div className="group-label">
              <label aria-hidden="true" htmlFor="employeur" className="field-label">{getKeyFromKeyId("EFFECTIF_EMPL")}</label></div>
              <select {...register('selectedEffectifEmployeur')} className="select-field w-select inputFixedMaxHeight">
              {
                codeListForm.clEmplWorkforce.map(item => <option key={item.keyId + item.keyValNum} value={item.keyValNum}>{getCodeListKey(item.keyId, item.keyValNum)}</option>)
              }
            </select>
          </div>
          <div id="group-field-precompte" className="group-field">
            <div className="group-label"><label aria-hidden="true" htmlFor="precompte" className="field-label">{getKeyFromKeyId("SOUMIS_PREC")}</label></div>
            <select {...register('selectedSoumisPrecompte')} className="select-field w-select inputFixedMaxHeight">
            {
              codeListForm.clDeduction.map(item => <option key={item.keyId + item.keyValNum} value={item.keyValNum}>{getCodeListKey(item.keyId, item.keyValNum)}</option>)
            }
           </select>
          </div>

          <FormToggleElementDualChoice defaultValueState={!formPartTimeValue} translationTitle={getKeyFromKeyId("WORK_REGIME")} translationValueLeft={getKeyFromKeyId("PART")} translationValueRight={getKeyFromKeyId("FULL")} valueUpdateCallback={TogglePartialTimeState} cssClass={"group-toggle toggleTwoColumn"} id={"w-node-_6248c31d-0976-4575-e126-4bde782800ff-c4011527"} />
          
          {formPartTimeValue && 
          <div id="table-horaire" aria-label={getKeyFromKeyId("TABLE_WORK_REGIME")} className="table-horaire w-node-_227bd29b-39a2-d0be-4db7-8064283b0864-d66cf1d1">
            <h3 aria-label={getKeyFromKeyId("FILL_WORK_REGIME")} className="intro-table">{getKeyFromKeyId("FILL_WORK_REGIME")}</h3>
            <div className="div-block-3">
              <section className="section">
                <h4 className="h4-table">{getKeyFromKeyId("WORKER")}</h4>
                <div className="group-days">
                  <div className="group-day"><label aria-hidden="true" htmlFor="monday" className="day">{getKeyFromKeyId("MONDAY")}</label>
                    <input type="text" {...withHookFormMask(register('MondaySchedule',{ onChange: (e) => RefreshScheduleDays(e, true)}), ['99:99','9:99'])} id="monday" className="time w-input" />
                    {errors?.MondaySchedule && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.MondaySchedule.message as any)}</p>}
                  </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="tuesday" className="day">{getKeyFromKeyId("TUESDAY")}</label>
                    <input type="text" {...withHookFormMask(register('TuesdaySchedule',{ onChange: (e) => RefreshScheduleDays(e,true)}), ['99:99','9:99'])} id="tuesday" className="time w-input" />
                    {errors?.TuesdaySchedule && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.TuesdaySchedule.message as any)}</p>}
                  </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="wednesday" className="day">{getKeyFromKeyId("WEDNESDAY")}</label>
                    <input type="text" {...withHookFormMask(register('WednesdaySchedule',{ onChange: (e) => RefreshScheduleDays(e,true)}), ['99:99','9:99'])} id="wednesday" className="time w-input" />
                    {errors?.WednesdaySchedule && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.WednesdaySchedule.message as any)}</p>}
                    </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="thursday" className="day">{getKeyFromKeyId("THURSDAY")}</label>
                    <input type="text" {...withHookFormMask(register('ThursdaySchedule',{ onChange: (e) => RefreshScheduleDays(e,true)}), ['99:99','9:99'])} id="thursday" className="time w-input" />
                    {errors?.ThursdaySchedule && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.ThursdaySchedule.message as any)}</p>} 
                  </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="friday" className="day">{getKeyFromKeyId("FRIDAY")}</label>
                    <input type="text" {...withHookFormMask(register('FridaySchedule',{ onChange: (e) => RefreshScheduleDays(e,true)}), ['99:99','9:99'])} id="friday" className="time w-input" />
                    {errors?.FridaySchedule && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.FridaySchedule.message as any)}</p>}
                    </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="saturday" className="day">{getKeyFromKeyId("SATURDAY")}</label>
                    <input type="text" {...withHookFormMask(register('SaturdaySchedule',{ onChange: (e) => RefreshScheduleDays(e,true)}), ['99:99','9:99'])} id="saturday" className="time w-input" />
                    {errors?.SaturdaySchedule && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.SaturdaySchedule.message as any)}</p>}
                  </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="sunday" className="day">{getKeyFromKeyId("SUNDAY")}</label>
                    <input type="text" {...withHookFormMask(register('SundaySchedule',{ onChange: (e) => RefreshScheduleDays(e,true)}), ['99:99','9:99'])} id="sunday" className="time w-input" />
                    {errors?.SundaySchedule && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.SundaySchedule.message as any)}</p>}
                  </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="totalDays" className="day scheduleTotalTitle">{isAtBreakpoint?getKeyFromKeyId("SCHEDULE_TOTAL_EMPLOYEE"):getKeyFromKeyId("SCHEDULE_TOTAL")}</label>
                    <div className="time scheduleTotal">{formScheduleTotalEmployee}</div>
                  </div>
                </div>
              </section>
              <div className="separator"></div>
              <section>
                <h4 className="h4-table">{getKeyFromKeyId("REFERENCE")}</h4>
                <div className="group-days">
                  <div className="group-day"><label aria-hidden="true" htmlFor="monday-2" className="day">{getKeyFromKeyId("MONDAY")}</label>
                    <input type="text" {...withHookFormMask(register('MondayScheduleRef',{ onChange: (e) => RefreshScheduleDays(e,false)}), ['99:99','9:99'])} id="monday-2" className="time w-input" />
                    {errors?.MondayScheduleRef && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.MondayScheduleRef.message as any)}</p>}
                  </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="tuesday-2" className="day">{getKeyFromKeyId("TUESDAY")}</label>
                    <input type="text" {...withHookFormMask(register('TuesdayScheduleRef',{ onChange: (e) => RefreshScheduleDays(e,false)}), ['99:99','9:99'])} id="tuesday-2" className="time w-input" />
                    {errors?.TuesdayScheduleRef && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.TuesdayScheduleRef.message as any)}</p>}
                    </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="wednesday-2" className="day">{getKeyFromKeyId("WEDNESDAY")}</label>
                    <input type="text" {...withHookFormMask(register('WednesdayScheduleRef',{ onChange: (e) => RefreshScheduleDays(e,false)}), ['99:99','9:99'])} id="wednesday-2" className="time w-input" />
                    {errors?.WednesdayScheduleRef && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.WednesdayScheduleRef.message as any)}</p>}
                    </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="thursday-2" className="day">{getKeyFromKeyId("THURSDAY")}</label>
                    <input type="text" {...withHookFormMask(register('ThursdayScheduleRef',{ onChange: (e) => RefreshScheduleDays(e,false)}), ['99:99','9:99'])} id="thursday-2" className="time w-input" />
                    {errors?.ThursdayScheduleRef && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.ThursdayScheduleRef.message as any)}</p>}
                    </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="friday-2" className="day">{getKeyFromKeyId("FRIDAY")}</label>
                    <input type="text" {...withHookFormMask(register('FridayScheduleRef',{ onChange: (e) => RefreshScheduleDays(e,false)}), ['99:99','9:99'])} id="friday-2" className="time w-input" />
                    {errors?.FridayScheduleRef && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.FridayScheduleRef.message as any)}</p>}
                    </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="saturday-2" className="day">{getKeyFromKeyId("SATURDAY")}</label>
                    <input type="text" {...withHookFormMask(register('SaturdayScheduleRef',{ onChange: (e) => RefreshScheduleDays(e,false)}), ['99:99','9:99'])} id="saturday-2" className="time w-input" />
                    {errors?.SaturdayScheduleRef && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.SaturdayScheduleRef.message as any)}</p>}
                    </div>
                  <div className="group-day"><label aria-hidden="true" htmlFor="sunday-2" className="day">{getKeyFromKeyId("SUNDAY")}</label>
                    <input type="text" {...withHookFormMask(register('SundayScheduleRef',{ onChange: (e) => RefreshScheduleDays(e,false)}), ['99:99','9:99'])} id="sunday-2" className="time w-input" />
                    {errors?.SundayScheduleRef && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.SundayScheduleRef.message as any)}</p>}
                    </div>
                    <div className="group-day"><label aria-hidden="true" htmlFor="totalDaysRef" className="day scheduleTotalTitle">{isAtBreakpoint?getKeyFromKeyId("SCHEDULE_TOTAL_EMPLOYER"):getKeyFromKeyId("SCHEDULE_TOTAL")}</label>
                    <div className="time scheduleTotal">{formScheduleTotalEmployer}</div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        }
        </form>
        </div>
  
    );

}

export default Step2Advanced;